<template lang="pug">
    div
        q_searchable_static_ddl(
        question="Honors and Awards"
        slug="q_awards_award"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Comments"
        slug="q_awards_comments"
        :multi_field_num="multi_field_num"
        )
        big Grades Participated in
        q_checkbox(
        question="9"
        slug="q_awards_9"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="10"
        slug="q_awards_10"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="11"
        slug="q_awards_11"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="12"
        slug="q_awards_12"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="Post Graduation"
        slug="q_awards_pg"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="Continue"
        slug="q_awards_continue"
        :multi_field_num="multi_field_num"
        )
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_checkbox from "../../baseQuestion/checkbox";
import q_searchable_static_ddl from "../../baseQuestion/searchableStaticDDL";
import q_text from "../../baseQuestion/text";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_checkbox,
		q_searchable_static_ddl,
		q_text
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		}
	}
};
</script>
